import DeliverySelect from "./pages/delivery_select";

document.addEventListener("DOMContentLoaded", function () {
  new DeliverySelect();
});